<template>
  <div class="view view__brand">
    <loader v-if="showLoader"></loader>
    <div class="row no-gutters justify-content-center">
      <div class="col col-md-6 col-lg-4">
        <navigation
          v-on:select-user="showUserPanel = !showUserPanel"
        ></navigation>

        <user-panel
          v-if="showUserPanel"
          v-body-scroll-lock="showUserPanel"
          v-on:close="showUserPanel = false"
        ></user-panel>

        <swiper
          class="BDRS-m MB-m"
          :options="swiperOptions"
        >
          <swiper-slide
            v-for="(banner, index) in banners"
            v-bind:key="'banner#' + index"
          >
            <img class="brand__banner" :src="banner">
          </swiper-slide>
        </swiper>
        <div class="brand__header MT-m MB-m">
          <div class="brand__name TA-c FW-b FZ-24 LH-150">
            {{ brandName }}
          </div>
          <div class="C-grey TA-c FZ-14 LH-140">{{ $t('home.OcardOnlineOrdering') }}</div>
        </div>

        <custom-select
          id="selected-subbrand"
          class="M-m"
          :label="$t('brand.brand')"
          :options="subBrands"
          v-model="selectedSubBrand"
          v-if="subBrands.length > 1"
        >
          <template v-slot:icon>
            <span class="material-icons-round icon MR-m">apps</span>
          </template>
        </custom-select>

        <custom-select
          id="selected-service-type"
          class="M-m"
          :label="$t('home.filter')"
          :options="orderTypeList"
          v-model="selectedOrderType"
        >
          <template v-slot:icon>
            <span class="material-icons-round icon MR-m">store</span>
          </template>
        </custom-select>

        <div class="brand__finder PL-m PR-m">
          <div class="brand__store-tab">
            <tab-item
              class="MR-xxs"
              :class="{'is-active': selectedFinderMode === 'AREA'}"
              v-on:click.native="selectedFinderMode = 'AREA'"
            >
              <template v-slot:icon>
                <span class="material-icons-round">map</span>
              </template>
              <template v-slot:label>
                {{ $t('home.areaFilter') }}
              </template>
            </tab-item>
            <tab-item
              class="ML-xxs"
              :class="{'is-active': selectedFinderMode === 'LOCATION'}"
              v-on:click.native="selectedFinderMode = 'LOCATION'"
            >
              <template v-slot:icon>
                <span class="material-icons-round">my_location</span>
              </template>
              <template v-slot:label>
                {{ $t('home.nearBy') }}
              </template>
            </tab-item>
          </div>
          <template v-if="selectedFinderMode === 'AREA' && country === 'TW'">
            <div class="row no-gutters MT-m MB-s">
              <div
                class="col"
                :class="{ 'MR-xxs': selectedCity !== 'none'}"
              >
                <custom-select
                  id="selected-city"
                  class=""
                  :label="$t('home.county')"
                  :options="cityList"
                  :labelFunction="getSelectLabel"
                  v-model="selectedCity"
                >
                  <template v-slot:icon>
                    <span class="material-icons-round icon MR-m">near_me</span>
                  </template>
                </custom-select>
              </div>
              <div
                class="col ML-xxs"
                v-show="selectedCity !== 'none'"
              >
                <custom-select
                  id="selected-area"
                  class=""
                  :label="$t('home.area')"
                  :options="areaList[selectedCity]"
                  :labelFunction="getSelectLabel"
                  v-model="selectedArea"
                >
                  <template v-slot:icon>
                    <span class="material-icons-round icon MR-m">layers</span>
                  </template>
                </custom-select>
              </div>
            </div>
          </template>
        </div>

        <div
          class="brand__stores M-m P-xl BDRS-m BGC-light C-grey TA-c FZ-14 LH-140"
          v-if="!storeUpdating && filteredStores.length === 0">
          {{ $t('brand.notMatching') }}
        </div>

        <div
          class="MT-m PR-m PL-m BDRS-m FZ-12 C-grey TA-c LH-140"
          v-if="selectedFinderMode === 'LOCATION'"
        >
          {{ $t('home.distancesDesc') }}<br>{{ $t('home.deliveryServicesDesc') }}
        </div>

        <div class="brand__stores MT-m MB-m">
          <BrandStore
            v-for="store in filteredStores"
            :store="store"
            :selectedFinderMode="selectedFinderMode"
            :key="store.token"
          ></BrandStore>
        </div>

        <div class="ocard MT-xl P-m TA-c FZ-12 LH-140 C-grey">
          <img class="D-b ML-a MR-a MB-m" src="https://ocard.co/assets/img/powered-by.svg" alt="Powered by Ocard">
          {{ $t('store.serviceProvided{name}', {
            name: brandName
          }) }}
          <div class="terms MT-xxs MB-xxs">
            <a href="https://ocard.co/privacy" target="blank">{{ $t('userPanel.privacyPolicy') }}</a>・<a href="https://ocard.co/terms" target="blank">{{ $t('userPanel.terms') }}</a>
          </div>
          {{ VUE_APP_VERSION }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import Axios from '@/helpers/axios';
import Swal from 'sweetalert2';
import { cityList, areaList } from '@/helpers/list';

import loader from '@/components/UI/Loader.vue';
import navigation from '@/components/Navigation.vue';
import userPanel from '@/components/UserPanel.vue';
import customSelect from '@/components/form/Select.vue';
import tabItem from '@/components/UI/TabItem.vue';
import BrandStore from '@/components/BrandStore.vue';

export default {
  components: {
    Swiper,
    SwiperSlide,
    loader,
    customSelect,
    tabItem,
    navigation,
    userPanel,
    BrandStore,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      showLoader: true,
      storeUpdating: false,
      showUserPanel: false,

      selectedOrderType: 'ALL',

      selectedFinderMode: 'AREA',

      selectedCity: 'none',
      cityList,

      selectedArea: '',
      areaList,

      banners: [],
      brandName: '',
      brandLogo: '',
      country: '',
      stores: [],
      storesLoading: true,
      subBrands: [],
      selectedSubBrand: 'ALL',

      swiperOptions: {
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
      },

      lat: null,
      lng: null,

    };
  },
  computed: {
    VUE_APP_VERSION() {
      return this.$store.state.VUE_APP_VERSION;
    },
    filteredStores() {
      if (this.selectedSubBrand === 'ALL') return this.stores;

      return this.stores.filter((store) => store.isSub === this.selectedSubBrand);
    },
    orderTypeList() {
      return [
        {
          label: this.$i18n.t('home.allStores'),
          value: 'ALL',
        },
        {
          label: this.$i18n.t('home.deliveryService'),
          value: 'DELIVERY',
        },
        {
          label: this.$i18n.t('home.pickupService'),
          value: 'PICKUP',
        },
      ];
    },
  },
  methods: {
    getSelectLabel(label) {
      return this.$i18n.t(label);
    },
    getBrand() {
      const data = {
        ...this.$route.query,
        brand_id: this.$route.params.brandId,
      };

      if (this.selectedFinderMode === 'LOCATION') {
        data.lat = this.lat;
        data.lng = this.lng;
      }

      this.storesLoading = true;

      Axios({
        method: 'post',
        url: '/brand/get',
        data,
      })
        .then((response) => {
          if (response.data.code !== 500) {
            if (response.data.msg) {
              Swal.fire({
                text: response.data.msg,
              })
                .then(() => {
                  if (response.data.reload) {
                    window.location.reload();
                  }

                  if (response.data.redirect) {
                    this.$router.push(response.data.redirect);
                  }
                });
            } else {
              if (response.data.reload) {
                window.location.reload();
              }

              if (response.data.redirect) {
                this.$router.push(response.data.redirect);
              }
            }
          }

          if (response.data.code === 500) {
            this.banners = response.data.data.brand.banner;
            this.brandName = response.data.data.brand.name;
            document.title = `${response.data.data.brand.name} | ${this.$i18n.t('home.OcardOnlineOrdering')}`;
            this.brandLogo = response.data.data.brand.image_logo;

            if (response.data.data.selected_city) {
              this.selectedCity = response.data.data.selected_city;
              this.selectedArea = response.data.data.selected_city;
            }

            this.country = response.data.data.brand.country;

            this.stores = response.data.data.stores;

            if (response.data.data.subBrands) {
              this.subBrands = [
                {
                  label: this.$i18n.t('brand.allBrands'),
                  value: 'ALL',
                },
                ...response.data.data.subBrands,
              ];
            }

            this.showLoader = false;
            this.storesLoading = false;
          }
        });
    },
    getStores() {
      const data = {
        ...this.$route.query,
        brand_id: this.$route.params.brandId,
        orderType: this.selectedOrderType,
        finder: this.selectedFinderMode,
      };

      if (this.selectedFinderMode === 'LOCATION') {
        data.lat = this.lat;
        data.lng = this.lng;
      }

      if (this.selectedFinderMode === 'AREA') {
        if (this.selectedCity !== 'none') {
          data.address = `${this.selectedArea}`;
        }
      }

      this.storeUpdating = true;

      this.stores = [];

      Axios({
        method: 'post',
        url: '/brand/storeList',
        data,
      })
        .then((response) => {
          if (response.data.code !== 500) {
            if (response.data.msg) {
              Swal.fire({
                text: response.data.msg,
              });
            }
            return;
          }
          this.storeUpdating = false;
          this.stores = response.data.data.stores;
        });
    },
  },
  watch: {
    selectedOrderType() {
      this.$nextTick(() => {
        this.getStores();
      });
    },
    selectedFinderMode(newVal) {
      if (newVal === 'LOCATION') {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              this.stores = [];
              this.lat = position.coords.latitude;
              this.lng = position.coords.longitude;

              this.$nextTick(() => {
                this.getStores();
              });
            },
            (error) => {
              let errorText;
              switch (error.code) {
                case 1:
                  errorText = this.$i18n.t('home.notAuthorizedAccessLocation');
                  break;

                case 2:
                  errorText = this.$i18n.t('home.unableAccessLocationError');
                  break;

                case 3:
                  errorText = this.$i18n.t('home.adjustYourSettings');
                  break;

                default:
                  errorText = this.$i18n.t('home.unableAccessLocation');
                  break;
              }
              Swal.fire({
                text: errorText,
              })
                .then(() => {
                  this.selectedFinderMode = 'AREA';
                });
            },
            {
              enableHighAccuracy: false,
              timeout: 10000,
              maximumAge: 60 * 30 * 1000,
            },
          );
        } else {
          Swal.fire({
            text: this.$i18n.t('home.unableAccessLocation'),
          });
        }
      } else {
        this.stores = [];

        this.$nextTick(() => {
          this.getStores();
        });
      }
    },
    selectedCity(newVal) {
      if (newVal !== 'none') {
        this.selectedArea = newVal;
      }

      this.$nextTick(() => {
        this.getStores();
      });
    },
    selectedArea() {
      this.$nextTick(() => {
        this.getStores();
      });
    },
  },
  mounted() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        () => {
          this.selectedFinderMode = 'LOCATION';
          this.getBrand();
        },
        () => {
          this.getBrand();
        },
        {
          enableHighAccuracy: false,
          timeout: 3000,
          maximumAge: 60 * 30 * 1000,
        },
      );
    } else {
      this.getBrand();
    }

    if (this.$route.query?.['is-sub']) this.selectedSubBrand = this.$route.query?.['is-sub'];
  },
};
</script>

<style lang="sass" scoped>
.brand
  &__banner
    width: 100%
    height: auto

  &__store-tab
    display: flex
    flex-direction: row

    &__item
      flex-grow: 1
      display: flex
      flex-direction: column
      justify-content: center

      transition: background .25s $cb

      &.is-active
        @extend .BGC-brand
        @extend .FW-b
        @extend .C-dark

.ocard
  .terms
    a
      color: currentcolor
      text-decoration: underline
</style>
